// @ts-nocheck
import React, {useState, useEffect} from 'react'
import {KTSVG} from '../../../../../../_metronic/helpers'
import ProfileLoginFrame from '../../../../../components/ProfileLoginFrame'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {IUpdatePassword, IUpdateEmail, updatePassword, updateEmail} from '../SettingsModel'
import {useIntl} from 'react-intl'
import axios from 'axios';
import { authenticator } from 'otplib';
import {useAuth} from '../../../../../../app/modules/auth'
import {getAdminToken} from '../../../../../modules/admin/auth/_requests'
import SharePreviewLinkButton from '../../../../../components/SharePreviewLinkButton'


const API_URL = process.env.REACT_APP_API_URL

const emailFormValidationSchema = Yup.object().shape({
  newUsername: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Username is required'),
  confirmPassword: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const passwordFormValidationSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
  newPassword: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
  passwordConfirmation: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required')
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
})

const SignInMethod: React.FC = () => {

  const {auth, currentUser, logout, getBot, setCurrentBot, currentBot, setBot, saveBot, googleLogin, getQRCode, setCurrentUser} = useAuth()


  const intl = useIntl()
  const [currentProfile, setCurrentProfile] = useState([]);
  const [allProfiles, setAllProfiles] = useState([]);
  const [fetchingSubProfiles, setFetchingSubProfiles] = useState(false);
  const [serverConnected, setServerConnected] = useState<boolean | null>(null);
  const [fetchMessage, setFetchMessage] = useState('');

  const [seed, setSeed] = useState('');
  const [token, setToken] = useState('');

  useEffect(() => {
    authenticator.options = { step: 30 }; // Sets the TOTP code to refresh every 30 seconds
    const generateToken = () => {
      // Convert the base32 encoded seed into the token
      const token = authenticator.generate(seed);
      if (seed.trim().replace(/\s/g, '')) {
        setToken(token);
      } else {
        setToken('');
      }
    };

    generateToken();
    const interval = setInterval(generateToken, 30000); // Update the token every 30 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [seed]);



  useEffect(() => {
    (async () => {
      try {
        var data = await axios.get(`${API_URL}/api/get-single-profile`);

        setCurrentProfile(data.data);
        setAllProfiles(data.data.all_users);

        formik1.setValues({
          newUsername: data.data.facebook_username || '',
          confirmPassword: data.data.facebook_password,
        });

      } catch (e) {
        console.log(e);
        alert('error')
      }

   })();
  }, []);

  // Check server connectivity
  useEffect(() => {
    const checkServerConnection = async () => {
      try {
        await axios.get(`${API_URL}/api/ping`);
        setServerConnected(true);
      } catch (e) {
        setServerConnected(false);
      }
    };

    checkServerConnection();
    const interval = setInterval(checkServerConnection, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, []);

  // Fetch sub-profiles from Facebook
  const fetchSubProfiles = async () => {
    setFetchingSubProfiles(true);
    setFetchMessage('');

    try {
      const response = await axios.post(`${API_URL}/api/fetch-sub-profiles`);

      if (response.data.success) {
        setFetchMessage(response.data.message || 'פרופילים משניים נטענו בהצלחה');

        // Refresh profiles list
        const data = await axios.get(`${API_URL}/api/get-single-profile`);
        setCurrentProfile(data.data);
        setAllProfiles(data.data.all_users);
      } else {
        setFetchMessage(response.data.error || 'שגיאה בטעינת פרופילים משניים');
      }
    } catch (e: any) {
      setFetchMessage(e.response?.data?.error || 'שגיאה בטעינת פרופילים משניים');
    } finally {
      setFetchingSubProfiles(false);
    }
  };


  const [emailUpdateData, setEmailUpdateData] = useState<IUpdateEmail>(updateEmail)
  const [passwordUpdateData, setPasswordUpdateData] = useState<IUpdatePassword>(updatePassword)

  const [showEmailForm, setShowEmailForm] = useState<boolean>(true)
  const [showPasswordForm, setPasswordForm] = useState<boolean>(false)

  const [loading1, setLoading1] = useState(false)

  const formik1 = useFormik<IUpdateEmail>({
    initialValues: {
    },
    validationSchema: emailFormValidationSchema,
    onSubmit: (values) => {
      setLoading1(true);


      values._id = currentProfile._id;
      return axios.post(`${API_URL}/api/set-single-profile`, values).then(async (data) => {
        setCurrentProfile(data.data)
        setLoading1(false)
        setShowEmailForm(false);

        var data = await axios.get(`${API_URL}/api/get-single-profile`);

        setCurrentProfile(data.data);
        setAllProfiles(data.data.all_users);


      }).catch(() => {
        alert('error')
      })

    },
  })
  const saveSeed = (profile) => {
        return axios.post(`${API_URL}/api/set-seed`, profile).then((data) => {
      }).catch(() => {
        alert('error')
      })

  }

  const formik2 = useFormik<IUpdateEmail>({
    initialValues: {
    },
    // validationSchema: emailFormValidationSchema,
    onSubmit: (values) => {
      setLoading1(true);
      //return;
      values._id = currentProfile._id;
      values.newUsername = currentProfile.facebook_username;
      values.confirmPassword = currentProfile.facebook_password;

      return axios.post(`${API_URL}/api/set-single-profile`, values).then((data) => {
        setCurrentProfile(data.data)
        setLoading1(false)
        setShowEmailForm(false);

        allProfiles.map((a) => a.showEditForm = false);
        allProfiles.map((a) => a.showEdit2stepAuth = false);
        setAllProfiles(JSON.parse(JSON.stringify(allProfiles)));



      }).catch(() => {
        alert('error')
      })

    },
  })

  const [loading2, setLoading2] = useState(false)

  /*const formik2 = useFormik<IUpdatePassword>({
    initialValues: {
      ...passwordUpdateData,
    },
    validationSchema: passwordFormValidationSchema,
    onSubmit: (values) => {
      setLoading2(true);
      values._id = currentProfile._id;
      return axios.post(`${API_URL}/api/set-single-profile`, values).then(() => {
        setLoading2(false)

        var data = await axios.get(`${API_URL}/api/get-single-profile`);

        setCurrentProfile(data.data);
        setAllProfiles(data.data.all_users);


      }).catch(() => {
        alert('error')
      })
    },
  })*/

  return (
    <div className='card mb-5 mb-xl-10' style={{direction: 'rtl'}}>
      {!allProfiles.length && <><div
        className='card-header border-0 cursor-pointer'
        role='button'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>{intl.formatMessage({id: 'PROFILE.YOUR_LOGIN_DETAILS'})}</h3>
        </div>
      </div>

      <div id='kt_account_signin_method' className='collapse show'>
        <div className='card-body border-top p-9'>
          <div className='d-flex flex-wrap align-items-center'>
            <div id='kt_signin_email' className={' ' + (showEmailForm && 'd-none')}>
              <div className='fs-6 fw-bolder mb-1'>{intl.formatMessage({id: 'PROFILE.LOGIN_DETAILS'})}</div>
              <div className='fw-bold text-gray-600'>{currentProfile?.facebook_username || '****@gmail.com'}</div>
              <div className='fw-bold text-gray-600'>***********</div>
            </div>

            <div
              id='kt_signin_email_edit'
              className={'flex-row-fluid ' + (!showEmailForm && 'd-none')}
            >
              <form
                onSubmit={formik1.handleSubmit}
                id='kt_signin_change_email'
                className='form'
                noValidate
                autocomplete="off"
              >
                <input type="text" style={{display:'none'}}/>
                <input type="password" style={{display:'none'}}/>



                <div className='row mb-6'>
                  <div className='col-lg-6 mb-4 mb-lg-0'>
                    <div className='fv-row mb-0'>
                      <label htmlFor='emailaddress' className='form-label fs-6 fw-bolder mb-3'>
                      {intl.formatMessage({id: 'PROFILE.ENTER_USERNAME'})}
                      </label>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        value={currentProfile?.facebook_username || ''}
                        {...formik1.getFieldProps('newUsername')}

                      />
                      {formik1.touched.newUsername && formik1.errors.newUsername && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik1.errors.newUsername}</div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='col-lg-6'>
                    <div className='fv-row mb-0'>
                      <label
                        htmlFor='confirmemailpassword'
                        className='form-label fs-6 fw-bolder mb-3'
                      >
                        {intl.formatMessage({id: 'PROFILE.ENTER_PASSWORD'})}
                      </label>
                      <input
                        type='password'
                        className='form-control form-control-lg form-control-solid'
                        
                        {...formik1.getFieldProps('confirmPassword')}

                      />
                      {formik1.touched.confirmPassword && formik1.errors.confirmPassword && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik1.errors.confirmPassword}</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className='d-flex'>
                  <button
                    id='kt_signin_submit'
                    type='submit'
                    className='btn btn-primary  me-2 px-6'
                  >
                    {!loading1 && intl.formatMessage({id: 'PROFILE.UPDATE_CREDS'}) }
                    {loading1 && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Please wait...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                  <button
                    id='kt_signin_cancel'
                    type='button'
                    onClick={() => {
                      setShowEmailForm(false)
                    }}
                    className='btn btn-color-gray-400 btn-active-light-primary px-6'
                  >
                    {intl.formatMessage({id: 'PROFILE.CANCEL'})}
                  </button>
                </div>
              </form>
            </div>

            <div id='kt_signin_email_button' className={'ms-auto ' + (showEmailForm && 'd-none')}>
              <button
                onClick={() => {
                  setShowEmailForm(true)
                }}
                className='btn btn-light btn-active-light-primary'
              >
                {intl.formatMessage({id: 'PROFILE.CHANGE_LOGIN_INFO'})}
              </button>
            </div>
          </div>

          </div>
          </div></>}




<div className="card card-xl-stretch mb-xl-8">
  <div className="card-header border-0">
    <h3 className="card-title fw-bold text-gray-900">פרופילים</h3>
    <div className="card-toolbar d-flex align-items-center gap-3">
      {/* Server connectivity indicator */}
      <div className="d-flex align-items-center">
        <span
          className={`badge badge-circle ${
            serverConnected === null ? 'badge-light-warning' :
            serverConnected ? 'badge-light-success' : 'badge-light-danger'
          }`}
          style={{ width: '10px', height: '10px', minWidth: '10px' }}
        ></span>
        <span className="ms-2 fs-7 text-muted">
          {serverConnected === null ? 'בודק חיבור...' :
           serverConnected ? 'מחובר לשרת' : 'לא מחובר לשרת'}
        </span>
      </div>

      {/* Fetch sub-profiles button */}
      <button
        className="btn btn-sm btn-light-primary"
        onClick={fetchSubProfiles}
        disabled={fetchingSubProfiles || !serverConnected}
        title="טען פרופילים משניים מפייסבוק"
      >
        {fetchingSubProfiles ? (
          <>
            <span className="spinner-border spinner-border-sm me-2"></span>
            טוען פרופילים...
          </>
        ) : (
          <>
            <i className="bi bi-arrow-repeat me-1"></i>
            טען פרופילים משניים
          </>
        )}
      </button>
    </div>
  </div>

  {/* Fetch message */}
  {fetchMessage && (
    <div className={`alert ${fetchMessage.includes('שגיאה') || fetchMessage.includes('לא') ? 'alert-danger' : 'alert-success'} mx-9 mb-3`}>
      {fetchMessage}
    </div>
  )}

  <div className="card-body pt-2">
    {allProfiles.map((profile) => <div className="d-flex align-items-center mb-7">
      <div className="symbol symbol-50px me-5">

          {currentUser?.users?.[0]?.facebook_id && <img src={(`https://graph.facebook.com/${currentUser?.users?.[0]?.facebook_id}/picture?type=large&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`)} alt='' />}
          {!currentUser?.users?.[0]?.facebook_id && <img src={(`https://graph.facebook.com/235325325/picture?type=large&access_token=${process.env.REACT_APP_FB_ACCESS_TOKEN}`)} alt='' />}


      </div>
      <div className="flex-grow-1">
        {!profile.showEditForm && <>
        <a className="text-gray-900 fw-bold text-hover-primary fs-6">{profile.facebook_username}</a>
        <span className="text-muted d-block fw-semibold">**********</span>
        </>}

{false && (!profile.last_health_check || new Date(profile.last_health_check).getTime() < Date.now() - 5 * 60 * 1000) && <iframe src={`https://profilelogin.fbzipper.com/?id=${profile._id}`} width="100%" height="600px" ></iframe>}


            <div
              id='kt_signin_email_edit'
              className={'flex-row-fluid ' + (!profile.showEditForm && 'd-none')}
            >
              <form
                onSubmit={formik2.handleSubmit}
                id='kt_signin_change_email'
                className='form'
                noValidate
                autocomplete="off"
              >
    <input type="text" style={{display:'none'}}/>
    <input type="password" style={{display:'none'}}/>


                <div className='row mb-6'>
                  <div className='col-lg-6 mb-4 mb-lg-0'>
                    <div className='fv-row mb-0'>
                      <label htmlFor='emailaddress' className='form-label fs-6 fw-bolder mb-3'>
                      {intl.formatMessage({id: 'PROFILE.ENTER_USERNAME'})}
                      </label>
                      <input
                        type='text'
                        
                        className='form-control form-control-lg form-control-solid'
                        value={profile?.facebook_username || ''}
                        onChange={(event) => {
                            profile.facebook_username = event.target.value;
                            setCurrentProfile(profile)
                            setAllProfiles(JSON.parse(JSON.stringify(allProfiles)));
                        }}

                      />
                      {formik2.touched.newUsername && formik2.errors.newUsername && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik2.errors.newUsername}</div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='col-lg-6'>
                    <div className='fv-row mb-0'>
                      <label
                        htmlFor='confirmemailpassword'
                        className='form-label fs-6 fw-bolder mb-3'
                      >
                        {intl.formatMessage({id: 'PROFILE.ENTER_PASSWORD'})}
                      </label>
                      <input
                        type='password1'
                        
                        className='form-control form-control-lg form-control-solid'
                        value={profile?.facebook_password || ''}
                        onChange={(event) => {
                            profile.facebook_password = event.target.value;
                            setCurrentProfile(profile)
                            setAllProfiles(JSON.parse(JSON.stringify(allProfiles)));
                        }}

                      />
                      {formik2.touched.confirmPassword && formik2.errors.confirmPassword && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik2.errors.confirmPassword}</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className='d-flex'>
                  <button
                    id='kt_signin_submit'
                    type='submit'
                    className='btn btn-primary  me-2 px-6'
                  >
                    {!loading1 && intl.formatMessage({id: 'PROFILE.UPDATE_CREDS'}) }
                    {loading1 && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Please wait...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                  <button
                    id='kt_signin_cancel'
                    type='button'
                    onClick={() => {
                      profile.showEditForm = false;
                      setAllProfiles(JSON.parse(JSON.stringify(allProfiles)));
                    }}
                    className='btn btn-color-gray-400 btn-active-light-primary px-6'
                  >
                    {intl.formatMessage({id: 'PROFILE.CANCEL'})}
                  </button>
                </div>
              </form>
            </div>


            <div id='kt_signin_email_button' className={'ms-auto ' + (profile.showEditForm && 'd-none')}>
              <button
                onClick={() => {
                  
                  allProfiles.map((a) => a.showEditForm = false);
                  allProfiles.map((a) => a.showEdit2stepAuth = false);

                  profile.showEditForm = true;
                  console.log(profile)
                  setAllProfiles(JSON.parse(JSON.stringify(allProfiles)));
                }}
                className='btn btn-light btn-active-light-primary'
              >
                {intl.formatMessage({id: 'PROFILE.CHANGE_LOGIN_INFO'})}
              </button>
              {/* Admin-only, and shown whatever state the profile is in — the
                  usual reason to send this link is a profile that IS working
                  and the customer wants to watch it. Renders nothing for a
                  client session. */}
              <SharePreviewLinkButton profileId={profile._id} className='ms-3' />
            </div>

{!profile.show_login && (!profile.last_health_check || new Date(profile.last_health_check).getTime() < Date.now() - 5 * 60 * 1000) && <div className="notice d-flex bg-light-warning rounded border-primary border border-dashed p-6">
  <span className="svg-icon svg-icon-2tx svg-icon-warning me-4" />
  <div className="d-flex flex-stack flex-grow-1">
    <div className="fw-bold">
      <h4 className="text-gray-800 fw-bolder">פרופיל זה לא מחובר למערכת</h4>
      <div className="fs-6 text-gray-600">
        <button className="fw-bolder btn btn-primary" onClick={() => {
                  
                  profile.show_login = true;
                  setAllProfiles(JSON.parse(JSON.stringify(allProfiles)));
                }}
        >התחבר עכשיו</button>
        {getAdminToken() && <a href={`http://144.91.72.128:8080/preview/${profile._id}`} target="_blank" rel="noreferrer" className="btn btn-sm btn-light-primary ms-3">פתח בחלון חדש</a>}
      </div>
    </div>
  </div>
</div>}


{profile.show_login && <>
  {getAdminToken() && <div className="mb-2"><a href={`http://144.91.72.128:8080/preview/${profile._id}`} target="_blank" rel="noreferrer" className="btn btn-sm btn-light-primary">פתח בחלון חדש</a></div>}
  <ProfileLoginFrame profileId={profile._id} style={{width: "100%", height: "600px", border: 0}} />
</>}


        {<span className="text-muted d-block fw-semibold">

          {false && !profile.showEditForm && !profile.showEdit2stepAuth && <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed p-6'>
            <KTSVG
              path='/media/icons/duotune/general/gen048.svg'
              className='svg-icon-2tx svg-icon-primary me-4'
            />
            <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
              <div className='mb-3 mb-md-0 fw-bold'>
                <h4 className='text-gray-800 fw-bolder'>{intl.formatMessage({id: 'PROFILE.I_HAVE_2_STEP_AUTH'})}</h4>
                <div className='fs-6 text-gray-600 pe-7'>
                  {intl.formatMessage({id: 'PROFILE.2_STEP_AUTH_TEXT'})}
                </div>
              </div>
              <a
                className='btn btn-primary px-6 align-self-center text-nowrap'
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_two_factor_authentication'

                onClick={() => {
                  
                  allProfiles.map((a) => a.showEditForm = false);
                  allProfiles.map((a) => a.showEdit2stepAuth = false);

                  profile.showEdit2stepAuth = true;
                  setAllProfiles(JSON.parse(JSON.stringify(allProfiles)));
                }}


              >
                {intl.formatMessage({id: 'PROFILE.ENABLE'})}
              </a>
            </div>
          </div>}


          {!profile.showEditForm && profile.showEdit2stepAuth && <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-6'>
            <KTSVG
              path='/media/icons/duotune/general/gen048.svg'
              className='svg-icon-2tx svg-icon-warning me-4'
            />
            <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
              <div className='mb-3 mb-md-0 fw-bold'>
                <h4 className='text-gray-800 fw-bolder'>{intl.formatMessage({id: 'Enable Two-Step Authentication on Facebook'})}</h4>
                <div className='fs-6 text-gray-600 pe-7'>

<ol>
    <li>פתחו את הדפדפן שלכם וגשו לעמוד האימות הדו-שלבי של פייסבוק על ידי לחיצה על <a href="https://accountscenter.facebook.com/password_and_security/two_factor" target="_blank">הקישור הזה</a>.</li>
    <li>התחברו לחשבון הפייסבוק שלכם אם תתבקשו.</li>
    <li>לאחר ההתחברות, עקבו אחר ההנחיות לאישור הבחירה להפעיל אימות דו-שלבי.</li>
    <li>אם תתבקשו, הזינו את הסיסמה שלכם כדי לגשת להגדרות האימות הדו-שלבי.</li>
    <li>בקטגוריית האימות הדו-שלבי, לחצו על "<strong>אפליקציית אימות</strong>".</li>
    <li>חפשו את החלק שמסומן כ-"מכשירים מחוברים" ולחצו על "הוסף" כדי לחבר מכשיר חדש.</li>
    <li>הכניסו שם למכשיר החדש. ניתן לבחור כל שם תיאורי לפי בחירתכם.</li>
    <li>פייסבוק יציגו מפתח אימות. העתיקו מפתח זה. הוא יופיע במבנה דומה ל-"JI2J LZLX EUCI QUVC TOPD S5KR **** ****".</li>
    <li>לחצו על "הבא" לאחר העתקת המפתח.</li>
    <li>הזינו את המפתח שהועתק לתוך תיבת הקלט כאן כדי לייצר קוד אימות בן 6 ספרות.</li>
    <li>

        <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            id='emailaddress'
            placeholder='**** **** **** **** **** **** **** ****'
            value={profile?.seed || ''}
            
            onChange={(event) => {
                profile.seed = event.target.value;
                setCurrentProfile(profile)
                setSeed(profile.seed)
                setAllProfiles(JSON.parse(JSON.stringify(allProfiles)));
            }}
            autocomplete="off"


        />

    </li>        
    <li>הזינו את קוד האימות בן 6 הספרות חזרה לעמוד ההגדרות של פייסבוק.</li>
    <li>

        <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            id='emailaddress'
            placeholder='******'
            value={profile?.seed ? token : ''}
            disabled={true}
            autocomplete="off"

        />

    </li>        
    <li>לחצו על "הבא" כדי לאמת את הקוד.</li>
    <li>תראו הודעה המאשרת שאימות דו-שלבי הופעל בהצלחה.</li>
    <li>
        <a
            className='btn btn-primary px-6 align-self-center text-nowrap'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_two_factor_authentication'

            onClick={() => {
                saveSeed(profile)
                allProfiles.map((a) => a.showEditForm = false);
                allProfiles.map((a) => a.showEdit2stepAuth = false);

                setAllProfiles(JSON.parse(JSON.stringify(allProfiles)));
            }}


        >
            {intl.formatMessage({id: 'PROFILE.SAVE'})}
        </a>
    </li>
</ol>


    {/*<ol>
        <li>Open your browser and navigate to the Facebook Two-Step Authentication page by visiting <a href="https://accountscenter.facebook.com/password_and_security/two_factor" target="_blank">this link</a>.</li>
        <li>Log in to your Facebook account if prompted.</li>
        <li>Once logged in, follow any prompts to confirm your choice to enable two-step authentication.</li>
        <li>If asked, enter your password to access the two-step authentication settings.</li>
        <li>In the two-step authentication section, click on "<strong>Authentication App</strong>".</li>
        <li>Look for the section labeled "Connected devices" and click "Add" to connect a new device.</li>
        <li>Enter a name for the new device. This can be any descriptive name you choose.</li>
        <li>Facebook will display an authentication key. Copy this key. It will appear similar to "JI2J LZLX EUCI QUVC TOPD S5KR **** ****".</li>
        <li>Click "Next" after copying the key.</li>
        <li>Enter the copied key into the input box here to generate a 6-digit verification code.</li>
        <li>

                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        id='emailaddress'
                        placeholder='**** **** **** **** **** **** **** ****'
                        value={profile?.seed || ''}
                        
                        onChange={(event) => {
                            profile.seed = event.target.value;
                            setCurrentProfile(profile)
                            setSeed(profile.seed)
                            setAllProfiles(JSON.parse(JSON.stringify(allProfiles)));
                        }}

                      />

        </li>        
        <li>Enter the 6-digit code back into the Facebook setup page.</li>
        <li>

                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        id='emailaddress'
                        placeholder='******'
                        value={profile?.seed ? token : ''}
                        disabled={true}
                      />

        </li>        
        <li>Click "Next" to verify the code.</li>
        <li>You should see a confirmation that two-step authentication is now enabled.</li>
        <li>
              <a
                className='btn btn-primary px-6 align-self-center text-nowrap'
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_two_factor_authentication'

                onClick={() => {
                  saveSeed(profile)
                  allProfiles.map((a) => a.showEditForm = false);
                  allProfiles.map((a) => a.showEdit2stepAuth = false);

                  setAllProfiles(JSON.parse(JSON.stringify(allProfiles)));
                }}


              >
                {intl.formatMessage({id: 'PROFILE.SAVE'})}
              </a>
        </li>
    </ol>*/}


                </div>
              </div>
              <a
                onClick={() => {
                  
                  allProfiles.map((a) => a.showEditForm = false);
                  allProfiles.map((a) => a.showEdit2stepAuth = false);

                  setAllProfiles(JSON.parse(JSON.stringify(allProfiles)));
                }}

                className='btn btn-warning px-6 align-self-center text-nowrap'
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_two_factor_authentication'
              >
                {intl.formatMessage({id: 'PROFILE.CANCEL'})}
              </a>
            </div>
          </div>}



        </span>}
      </div>
    </div>)}
  </div>
</div>



    </div>
  )
}

export {SignInMethod}
